export const SET_COMMUNITY_ID = "SET_COMMUNITY_ID";
export const SET_TEMPLATE_ID = "SET_TEMPLATE_ID";
export const SET_USER_DETAIL = "SET_USER_DETAIL";
export const TOGGEL_SIDEBAR = "TOGGEL_SIDEBAR";
export const ASSIGN_VALUE = "ASSIGN_VALUE";
export const GET_COMMUNITY_ID = "GET_COMMUNITY_ID";
export const SET_LANG_ID = "SET_LANG_ID";
export const SET_APP_VERSION = "SET_APP_VERSION";
export const SET_ONBOARD_PERNT = "SET_ONBOARD_PERNT";
export const SET_CHAT_TYPE = "SET_CHAT_TYPE";
export const SET_FIREBASE_USER_DETAIL = "SET_FIREBASE_USER_DETAIL";
export const SET_SELECTED_COMPONENT_OBJECT = "SET_SELECTED_COMPONENT_OBJECT";
export const RESET_SELECTED_COMPONENT_OBJECT = "RESET_SELECTED_COMPONENT_OBJECT";
export const SET_BOTTOM_NAV_COMPONENT_OBJECT = "SET_BOTTOM_NAV_COMPONENT_OBJECT";
export const PARTIAL_SET_SELECTED_COMPONENT_OBJECT = "PARTIAL_SET_SELECTED_COMPONENT_OBJECT";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_COMPBG_COLOR = "SET_COMPBG_COLOR";
export const SET_NOTI_OBJ = "SET_NOTI_OBJ";
export const SET_NOTI_COUNTER = "SET_NOTI_COUNTER";
export const SET_FORE_GROUND_NOTI = "SET_FORE_GROUND_NOTI";
export const SET_REGION_STATE_VALUE = 'SET_REGION_STATE_VALUE';
export const SET_FACILITY_STATE_VALUE = 'SET_FACILITY_STATE_VALUE';










